export default {
      id: "color_wgs_hh_2-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "sprite.svg#color_wgs_hh_2",
      toString: function () {
        return this.url;
      }
    }